<script>
import OrderList from '../OrderList'
export default {
  name: 'in-progress-orders',
  extends: OrderList,
  computed: {
    tabOrder () {
      return this.$store.getters.inProgressOrders
    },
    refreshMethod () {
      return 'getInProgressOrders'
    }
  },
  mounted () {
    this.$store.dispatch('getInProgressOrders')
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?595385c0